// Midnight Plum - "Firefly Game Shelf" approved palette
// Approved colors:
//   Midnight Plum #1A0A2E - backgrounds, headers, dark UI
//   Warm Amber #F4A261 - CTAs, highlights, action buttons
//   Sage Green #7EC8A0 - success states, availability indicators
//   Soft Cream #FFF8EE - card backgrounds, text areas, light base
//   Berry Wine #8B2252 - accents, badges, notification dots, borders
//   Dusty Lavender #B8A9C9 - secondary text, disabled states, subtle borders

export const lightTheme = {
  name: 'light',

  /* === Brand === */
  primaryColor: '#F4A261', // Warm Amber - CTAs, highlights
  primaryDark: '#D4884D', // Deeper amber - hover states
  secondaryColor: '#B8A9C9', // Dusty Lavender - secondary elements

  successColor: '#7EC8A0', // Sage Green - availability, success
  dangerColor: '#ef4444', // Red - errors, destructive actions
  warningColor: '#f59e0b', // Amber - warnings
  infoColor: '#B8A9C9', // Dusty Lavender - informational

  /* === Backgrounds === */
  bgPrimary: '#FFF8EE', // Soft Cream - main background
  bgSecondary: '#F5EDE0', // Slightly deeper cream
  bgTertiary: '#EDE4D6', // Warm tertiary

  background: '#EDE4D6', // Page background
  cardBackground: '#ffffff', // White cards
  hoverBackground: '#F5EDE0', // Warm hover

  /* === Text === */
  textPrimary: '#1A0A2E', // Midnight Plum
  textSecondary: '#4A2C5C', // Mid plum
  textMuted: '#6B5B7B', // Muted plum

  /* === Borders & Shadows === */
  borderColor: '#D4C4A8', // Warm border

  shadow: '0 1px 3px 0 rgba(26, 10, 46, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.14)',
  shadowLg:
    '0 10px 25px -5px rgba(26, 10, 46, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)',

  primaryHover: '#E8883D', // --primary-hover
  primaryStrong: '#B8692A', // --primary-strong (deep amber, gradient endpoint)
  accentColor: '#8B2252', // --accent-color (Berry Wine)
  shadowMd:
    '0 4px 12px -2px rgba(26, 10, 46, 0.22), 0 2px 6px -1px rgba(0, 0, 0, 0.18)', // --shadow-md
  shadowXl:
    '0 20px 50px -10px rgba(26, 10, 46, 0.45), 0 12px 20px -8px rgba(0, 0, 0, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(244, 162, 97, 0.12)', // --shadow-soft

  /* === Messaging / States === */
  primaryLight: 'rgba(244, 162, 97, 0.14)', // Warm Amber tint
  unreadBackground: 'rgba(244, 162, 97, 0.06)',
  messageBubbleBg: '#F5EDE0',
  messageReceivedBg: '#ffffff',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
};

export const darkTheme = {
  name: 'dark',

  /* === Brand === */
  primaryColor: '#F4A261', // Warm Amber - CTAs, highlights
  primaryDark: '#D4884D', // Deeper amber - hover states
  secondaryColor: '#B8A9C9', // Dusty Lavender - secondary elements

  successColor: '#7EC8A0', // Sage Green - availability, success
  dangerColor: '#ef4444', // Red - errors, destructive actions
  warningColor: '#f59e0b', // Amber - warnings
  infoColor: '#B8A9C9', // Dusty Lavender - informational

  /* === Backgrounds === */
  bgPrimary: '#0D0517', // Deep plum
  bgSecondary: '#1A0A2E', // Midnight Plum
  bgTertiary: '#2B1A3D', // Lighter plum

  background: '#0D0517', // Page background
  cardBackground: '#1A0A2E', // Midnight Plum cards
  hoverBackground: '#2B1A3D', // Hover

  /* === Text === */
  textPrimary: '#FFF8EE', // Soft Cream
  textSecondary: '#B8A9C9', // Dusty Lavender
  textMuted: '#8B7BA8', // Muted lavender

  /* === Borders & Shadows === */
  borderColor: '#4A2C5C', // Mid plum border

  shadow: '0 1px 3px 0 rgba(244, 162, 97, 0.3), 0 1px 2px 0 rgba(0, 0, 0, 0.8)',
  shadowLg:
    '0 18px 35px -10px rgba(0, 0, 0, 0.9), 0 0 40px rgba(244, 162, 97, 0.25)',

  primaryHover: '#FFBC86', // --primary-hover
  primaryStrong: '#FF8C3A', // --primary-strong (vivid amber, gradient endpoint)
  accentColor: '#7EC8A0', // --accent-color (Sage Green)
  shadowMd:
    '0 4px 12px -2px rgba(244, 162, 97, 0.25), 0 2px 6px -1px rgba(0, 0, 0, 0.6)', // --shadow-md
  shadowXl:
    '0 28px 60px -14px rgba(0, 0, 0, 0.95), 0 0 60px rgba(244, 162, 97, 0.35)', // --shadow-xl
  shadowSoft: 'rgba(244, 162, 97, 0.2)', // --shadow-soft

  /* === Messaging / States === */
  primaryLight: 'rgba(244, 162, 97, 0.3)', // Warm Amber tint
  unreadBackground: 'rgba(244, 162, 97, 0.16)',
  messageBubbleBg: '#2B1A3D',
  messageReceivedBg: '#3A2850',
  dangerLight: 'rgba(239, 68, 68, 0.25)',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
